import { ComponentStyleConfig } from "@chakra-ui/react";

export const ReiContainer: ComponentStyleConfig = {
  baseStyle: {
    maxW: "1440px",
  },
};
